module.exports = __webpack_public_path__ + "static/media/pumptec.bb30422a.pdf";